import { Component, Input, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
    selector: 'w-validation-panel',
    templateUrl: './w-validation-panel.component.html',
    host: {
        '[class.b-validation__issue--is-type_warning]': 'type === "warning"',
        '[class.b-validation__issue--is-type_error]': 'type === "error"',
        '[class.b-validation__issue--is-type_success]': 'type === "success"',
    },
    standalone: false
})
/*
@id w-validation-panel
@name w-validation-panel
@status release
@description Information panel. Use "type" to indicate warning, error, success
*/
export class WValidationPanelComponent {
  @Input() summary?: string;
  @Input() details?: string;
  @Input() type: string = ''; // @options[warning,error,success,<empty string>]
}
@NgModule({
  imports: [CommonModule],
  exports: [WValidationPanelComponent],
  declarations: [WValidationPanelComponent]
})
export class WValidationPanelModule { }
